'use client';

import { GetExperiencesFromCatgRes } from '@/actions/experiences/types';
import { CategorySections } from '@/components/CategorySections';
import { CustomBreadcrumb } from '@/components/CategorySections/CustomBreadcrumb';
import { ExperienceCategorySetDynamicUrls } from '@/components/SicilyPages/ExperienceCategorySetDynamicUrls';
import { useLocale } from '@/hooks/useLocale';
import React from 'react';

const LazyParagraph = React.lazy(() => import('../Paragraph'));

type ICategory = {
  catalog: NonNullable<GetExperiencesFromCatgRes['catalog']>;
  experiencesGroupedByCategory: NonNullable<
    GetExperiencesFromCatgRes['experiencesGroupedByCategory']
  >;
  category: NonNullable<GetExperiencesFromCatgRes['macroCategory']>;
};

export default function ExperienceCategory({
  catalog,
  experiencesGroupedByCategory,
  category,
}: ICategory) {
  const lang = useLocale();

  const categoryData = catalog?.catalogTranslation.find((item) => {
    if (item.locale === lang) {
      return item;
    }
  })!;

  return (
    <main className="px-sm md:px-md desktop:px-lg mb-36">
      <ExperienceCategorySetDynamicUrls category={category} />
      <CustomBreadcrumb categoryTitle={categoryData.title} />

      <div>
        <h1 className="mb-4 text-title font-noe">{categoryData.title}</h1>
        <div className="mb-12">
          <LazyParagraph
            content={categoryData.description ?? ''}
            className="mb-4 [&>a]:bg-gradient-to-b [&>a]:from-underline [&>a]:to-underline [&>a]:bg-no-repeat [&>a]:bg-[length:95%_3px] [&>a]:py-0 [&>a]:px-[5px] [&>a]:my-0 [&>a]:mx-[-5px] [&>a]:bg-bottom [&>a:hover]:bg-[length:95%_15px] [&>a]:transition-all [&>a]:ease-in-out [&>a]:duration-500 [&>a]:z-1 [&>a]:break-normal"
          />
        </div>
      </div>

      <CategorySections
        categoryTitle={categoryData.title}
        experiences={experiencesGroupedByCategory}
      />
    </main>
  );
}
